import React, { lazy, Suspense } from 'react';

const LazyUpdatePasswordSuccess = lazy(() => import('./UpdatePasswordSuccess'));

const UpdatePasswordSuccess = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
    <Suspense fallback={null}>
        <LazyUpdatePasswordSuccess {...props} />
    </Suspense>
);

export default UpdatePasswordSuccess;
